import { useEffect, useState } from 'react'
import { api } from '../api/client'
import { titleCase } from '../lib/format'
import { useAsync } from '../lib/useAsync'
import { Icon } from './Icon'

/** Pick people by name, one or many: used to hand-pick extras into a drip's
 *  audience, and to start a new workflow for someone the moment you save it. */
export function PeoplePicker({ selected, onChange, placeholder = 'Search to add specific people' }: {
  selected: { id: number; name: string | null }[]
  onChange: (people: { id: number; name: string | null }[]) => void
  placeholder?: string
}) {
  const [q, setQ] = useState('')
  const [term, setTerm] = useState('')
  useEffect(() => {
    const t = window.setTimeout(() => setTerm(q.trim()), 200)
    return () => window.clearTimeout(t)
  }, [q])
  const { data } = useAsync(() => (term.length >= 2 ? api.search(term) : Promise.resolve(null)), [term])
  const chosen = new Set(selected.map((s) => s.id))
  const results = (data?.leads ?? []).filter((l) => !chosen.has(l.id))

  return (
    <div>
      <div className="wb-chips" style={{ marginBottom: selected.length ? 6 : 0 }}>
        {selected.map((p) => (
          <span key={p.id} className="tag">{p.name ?? `#${p.id}`}
            <button type="button" onClick={() => onChange(selected.filter((s) => s.id !== p.id))} aria-label={`Remove ${p.name}`}><Icon name="close" size={13} /></button>
          </span>
        ))}
      </div>
      <div style={{ position: 'relative' }}>
        <input className="field" aria-label={placeholder} placeholder={placeholder} value={q} onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              const first = term === q.trim() ? results[0] : undefined
              if (first) { onChange([...selected, { id: first.id, name: first.full_name }]); setQ('') }
            }
            if (e.key === 'Escape') { e.stopPropagation(); setQ('') }
          }} />
        {term.length >= 2 && results.length ? (
          <div className="menu" style={{ top: '100%', left: 0, right: 0, marginTop: 4, maxHeight: 220, overflowY: 'auto' }}>
            {results.map((l) => (
              <button type="button" key={l.id} onClick={() => { onChange([...selected, { id: l.id, name: l.full_name }]); setQ('') }}>
                <Icon name="person_add" size={15} />
                <span>{l.full_name ?? '—'}<span className="hint" style={{ display: 'block' }}>{[l.city, titleCase(l.status)].filter(Boolean).join(' · ')}</span></span>
              </button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}
